import React, {useEffect, useState} from 'react'
import 'keen-slider/keen-slider.min.css'
import {useKeenSlider} from 'keen-slider/react' // import from 'keen-slider/react.es' for to get an ES module


export default function Slider({data, texts, haveTexts ,slideNumber}) {
    const [step, setStep] = useState(1)
    const [sliderRef, instanceRef] = useKeenSlider(
        {
            drag: false,
            slideChanged: () => {
            },
            slides:{spacing:1024}
        },
        [
            // add plugins here
        ]
    )
    useEffect(() => {
        if (step !== slideNumber) {
            stepMove(slideNumber - 1)
        }
    }, [slideNumber])


    const stepMove = (number) => {
        setStep(number + 1)
        instanceRef.current.moveToIdx(number)
    }
    return (
        <>
            <div className={'questionsAndTexts'}>
                <div style={haveTexts ? {width: '38%'} : {width: '100%'}}>
                    <div className="test-number-question">
                        {step}/{data.length}
                    </div>
                    <div ref={sliderRef} className="keen-slider">
                        {data}
                    </div>
                </div>
                {haveTexts && texts}
            </div>

        </>
    )
}
